// extracted by mini-css-extract-plugin
module.exports = {"imageSmile":"MyBooking_imageSmile__3Gl4g","heading":"MyBooking_heading__7frhK","noBooking":"MyBooking_noBooking__Pvy-K"};